// extracted by mini-css-extract-plugin
export default {"isCopiedContainer":"IsCopiedMessage_isCopiedContainer__4AUbH","active":"IsCopiedMessage_active__-U4ty"};